export const ATTRIBUTION_FIELDS = [
  'gclid',
  'wbraid',
  'gbraid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'landing_page_url',
  'first_touch_timestamp',
];

export const CLICK_AND_UTM_FIELDS = ATTRIBUTION_FIELDS.filter(
  (field) => !['landing_page_url', 'first_touch_timestamp'].includes(field)
);

const STORAGE_PREFIX = 'welliemd_attribution';

const getHostname = (hostname) => {
  if (hostname) return hostname;
  if (typeof window !== 'undefined' && window.location?.hostname) {
    return window.location.hostname;
  }
  return 'unknown-host';
};

const storageKeyForHostname = (hostname) => `${STORAGE_PREFIX}:${getHostname(hostname)}`;

const getStorage = () => {
  if (typeof window === 'undefined') return null;
  try {
    if (window.localStorage) return window.localStorage;
  } catch (error) {
    // Ignore blocked storage and fall back below.
  }
  try {
    if (window.sessionStorage) return window.sessionStorage;
  } catch (error) {
    // Browser storage is unavailable.
  }
  return null;
};

const cleanValue = (value) => {
  if (value === null || value === undefined) return null;
  const cleaned = String(value).trim();
  return cleaned || null;
};

const normalizeRecord = (record) => {
  if (!record || typeof record !== 'object') return null;
  const normalized = {};
  ATTRIBUTION_FIELDS.forEach((field) => {
    normalized[field] = cleanValue(record[field]);
  });
  return normalized;
};

const hasMarketingValue = (record) => (
  Boolean(record) && CLICK_AND_UTM_FIELDS.some((field) => Boolean(record[field]))
);

export const collectAttributionParams = (search = '') => {
  const params = new URLSearchParams(search || '');
  const record = {};
  CLICK_AND_UTM_FIELDS.forEach((field) => {
    record[field] = cleanValue(params.get(field));
  });
  return record;
};

export const getStoredAttribution = (hostname) => {
  const storage = getStorage();
  if (!storage) return null;

  try {
    const raw = storage.getItem(storageKeyForHostname(hostname));
    if (!raw) return null;
    return normalizeRecord(JSON.parse(raw));
  } catch (error) {
    return null;
  }
};

export const captureAttributionFromLocation = (
  location = typeof window !== 'undefined' ? window.location : null,
  timestamp = new Date().toISOString()
) => {
  if (!location) return null;

  const hostname = getHostname(location.hostname);
  const existing = getStoredAttribution(hostname);
  if (hasMarketingValue(existing)) {
    return existing;
  }

  const attributionParams = collectAttributionParams(location.search);
  if (!hasMarketingValue(attributionParams)) {
    return existing;
  }

  const record = normalizeRecord({
    ...attributionParams,
    landing_page_url: location.href,
    first_touch_timestamp: timestamp,
  });

  const storage = getStorage();
  if (storage) {
    try {
      storage.setItem(storageKeyForHostname(hostname), JSON.stringify(record));
    } catch (error) {
      // Attribution is best-effort and should never block checkout.
    }
  }

  return record;
};
